import React from 'react';


export const MainLoading = () => {

    return(
        <div className="center-container-holder">
            <div className="centered-container">
                <div className="center-holder loading-holder">
                    <div className="loader"></div>
                </div>
            </div>
        </div>
    )
};
